import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom'
import Aboutuslearners from '../Landing/Subcomponent/aboutuslearners';
import Aluminicompany from '../Landing/Subcomponent/aluminicompany';
import Whyedu from '../Landing/Subcomponent/whyedu';
import "../../css/course-page.css";

class Certificateinrprograming extends Component {
    render() {
        return (
            <div>
                <div aria-label="breadcrumb">
                    <ol class="breadcrumb">
                    <li class="breadcrumb-item"><Link ><FontAwesomeIcon icon={faHome} />  &nbsp; HOME</Link></li>
                        <li class="breadcrumb-item active" aria-current="page">Certificate Course in Data Analytics using R Programing</li>
                    </ol>
                </div>
            <section class="course-header r-python-color" id="course-header">
               <div class="row">
                  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-5">
                     <h1>Certificate Course in Data Analytics using R Programing<br /></h1><br />
                     <p>Accelerate your Career. Stay Ahead of the Curve </p><br /><br />

                     <div class="form-group">
                          <a href="#apply-now" class="btn btn-md enroll-btn">Enroll Now </a>
                      
                      <button type="button" class="btn btn-md download-bro-btn" data-toggle="modal" id="myBtn"
                           data-target="#myModal" onclick="return gtag_report_conversion('<?php echo $baseurl;?>course/certificate-course-in-data-analytics-using-r-programing');">Download
                        brochure</button> <br /><br /><br />
                       
                     </div>
                  </div>
                  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-2"></div>
                  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-5">
                
                     <p>Jointly Delivered by eduplusnow and Industry Expert </p>  <br />
                     <table class="table-highlight">
                        <tr>
                           <td> <img alt="executive2" width="" src="/assets/images/epn.svg" /></td>
                        </tr>
                     </table>
                     <br />
                  </div>
               </div>
            </section>

           


            <div class="course-main-contains def-z" id="Description">
                <div class="card" >
                    <div class="row contanint-display">
                        <div class="col-lg-4 col-xl-4 col-12 col-sm-12 col-md-4">    
                        <b><i class="fa fa-calendar" ></i>&nbsp;&nbsp;80 hours<br />
                        <i class="fa fa-tasks" ></i> &nbsp;&nbsp;WEEKDAY BATCH</b>  
                        </div>
                        <div class="col-lg-4 col-xl-4 col-12 col-sm-12 col-md-4">    
                        <b><i class="fa fa-calendar" ></i>&nbsp;&nbsp;80 hours<br />
                        <i class="fa fa-tasks" ></i> &nbsp;&nbsp; WEEKEND BATCH</b>
                        </div>
                        <div class="col-lg-4 col-xl-4 col-12 col-sm-12 col-md-4" id="Description">    
                     
                        </div>
                    </div>
                </div>
            </div>
            <section class="def-z">
            <div class="header" id="myHeader">
                    <ul>
                        <li><a href="#Description">Description</a></li>
                        <li><a href="#Industry">Industry Trends</a></li>
                        <li><a href="#tools">Tools</a></li>
                        <li><a href="#syllabus">Syllabus</a></li>               
                        <li><a href="#Outcomes">Learning Outcomes</a></li>           
                        <li><a href="#Review">Learner Review</a></li>          
                        <li class="btn-header cs-dx"><a href="#apply-now">Enroll Now</a></li>           
                    </ul>
            </div>
            </section>
           
            <section class="course-description " id="course-description">
               <br />
               <div class="row">
                  <div class="col-sm-12">
                     <h3>About Data Analytics using R</h3>
                     <p align = "justify"> Data Analytics is the application of structured statistical and mathematical techniques on collected data in order to detect underlying patterns as well as make predictions.</p>
                  </div>
                
               </div>
            
               <br />
               <div class="row">
                  <div class="col-sm-12">
                     <h4 >Course Features </h4>
                     <p align = "justify"  id="Industry">Data Analytics course will master you in R Studio platform using  Data Prepration, Basic Analytics, Prescriptive Analytics,Exploratory Data Analytics, Descriptive Analytics & Predictive analytics using Classification, Clustering & Time Series  Analytics.</p>
                  </div>
               </div>
               <br />
               <div class="row">
                  <div class="col-sm-12">
                     <h5> Who Should Enroll? </h5>
                     <p align = "justify">Any fresher & professional, Engineers, Marketing & Sales professionals, Domain Experts, Software & IT Professionals.</p>
                  </div>
               </div>
            </section>
           
            <section class="course-industry-trends bg-secondary" id="course-industry-trends">
               <div class="row">
                  <div class=" col-md-6 col-sm-12">
                     <h3> Industry Trends </h3>
                     <br />
                     <h5>Job Roles</h5>
                     <ul class="industry-trends-ul">
                        <li>Data Analyst</li>
                        <li>Data Engineer</li>
                        <li>Data Sceintist</li>
                        <li id="tools">Stastician</li>
                     </ul>
                  </div>
                  <div class="col-md-6 col-sm-12">
                     <img alt="datascience11" src="/assets/images/icons/industry-trends.svg" />
                  </div>
               </div>
            </section>
           
            <br /> 
            <section class="course-tools-covered" id="course-tools-covered">
               <h3> Tools Covered </h3>
               <br />
               <div class="owl-carousel owl-theme" id="owl-carousel-course-tools">
                  <div class="item">
                     <div class="card" >
                        <center id="syllabus">
                            <img alt="rstudio-logo" src="/assets/images/icons/rstudio-logo.png" /> </center>
                     </div>
                    </div>
                   <div class="item">
                     <div class="card" >
                        <center>
                        <img alt="python-logo" src="/assets/images/icons/python-logo.svg" /> </center>
                     </div>
                    </div>
               </div>
            </section>
            
            <section class="course-syllabus" id="course-syllabus">
                <div class="row" >
                    <div class="col-sm-12 col-md-12 col-lg-12 col-xl-10">
                        <br />
                         <h3> Syllabus </h3>
                        <br />
                        <div class="syl-bg">
                     <div id="de_syllabus">
                        <div class="panel-group">
                           <div class="panel panel-info">
                              <div class="panel-heading" id="de_heading1" data-toggle="collapse"
                                 href="#de_syllabus1" aria-expanded="true" aria-controls="de_syllabus1">
                                 <h6 class="panel-title">
                                    <i class="indicator fa fa-minus"></i> Steps of analytics
                                 </h6>
                              </div>
                              <div id="de_syllabus1" class="collapse show" aria-labelledby="de_heading1"
                                 data-parent="#de_syllabus">
                                 <div class="panel-body">
                                    <ul class="syllabus-ul">
                                    <li> Data Preparation </li>
                                    <li>Data Preparation & selection case study  </li>
                                    <li>Basic Analytics  </li>
                                    <li> Data Visualization / Visual Analytics</li>
                                    <li> Exploratory Data Analytics</li>
                                    <li> -System of BI & EDA </li>
                                    <li> -Univariate / Multivariate/ Pair wise </li>
                                    <li> -Binary / Ordinal / Categorical / discrete continues </li>
                                    <li> Prescriptive Analytics – Classification Modeling</li>
                                    <li> Descriptive Analytics – Clustering & MBA </li> 
                                    <li> Predictive Analytics - Time Series Analytics </li>
                                    </ul>
                                 </div>
                              </div>
                           </div>
                          
                           <div class="panel panel-info">
                              <div class="panel-heading" id="de_heading2" data-toggle="collapse"
                                 href="#de_syllabus2" aria-expanded="true" aria-controls="de_syllabus2">
                                 <h6 class="panel-title">
                                    <i class="indicator fa fa-minus"></i> Probability & Probability distribution
                                 </h6>
                              </div>
                              <div id="de_syllabus2" class="collapse show" aria-labelledby="de_heading2"
                                 data-parent="#de_syllabus">
                                 <div class="panel-body">
                                    <ul class="syllabus-ul">
                                    <li> Summary of statistics & graphs</li>
                                    <li> Estimation – maximum likelihood estimation </li>
                                    <li> Expectation </li>
                                    <li> Exercise – Probability Based Predictive Model, Conditional,
                                             Mutual Independent Probability Bayesian Theory </li>
                                    </ul>
                                 </div>
                              </div>
                           </div>
                        
                           <div class="panel panel-info">
                              <div class="panel-heading" id="de_heading4" data-toggle="collapse"
                                 href="#de_syllabus4" aria-expanded="true" aria-controls="de_syllabus4">
                                 <h6 class="panel-title">
                                    <i class="indicator fa fa-minus"></i>Explanatory variables & 1 Target Variable  
                                 </h6>
                              </div>
                           </div>
                           </div>
                         
                           <div class="panel panel-info">
                              <div class="panel-heading" id="de_heading5" data-toggle="collapse"
                                 href="#de_syllabus5" aria-expanded="true" aria-controls="de_syllabus5">
                                 <h6 class="panel-title">
                                   <i class="indicator fa fa-minus"></i>Multivariate Statistics
                                 </h6>
                              </div>
                              <div id="de_syllabus5" class="collapse show" aria-labelledby="de_heading5"
                                 data-parent="#de_syllabus">
                                 <div class="panel-body">
                                    <ul class="syllabus-ul">
                                    <li> Multivariate fenomenal </li>
                                    <li> Variance – co variance metrics </li>
                                    <li> Co relation metrics </li>
                                    <li> MANOVA(Multivariate ANOVA) </li>
                                    <li> PCA ( Principal component analysis) </li>
                                    <li> FA( Factor Analysis) </li>
                                    </ul>
                                 </div>
                              </div>
                           </div>
                         
                           <div class="panel panel-info">
                              <div class="panel-heading" id="de_heading6" data-toggle="collapse"
                                 href="#de_syllabus6" aria-expanded="true" aria-controls="de_syllabus6">
                                 <h6 class="panel-title">
                                    <i class="indicator fa fa-minus"></i>Modeling
                                 </h6>
                              </div>
                              <div id="de_syllabus6" class="collapse show" aria-labelledby="de_heading6"
                                 data-parent="#de_syllabus">
                                 <div class="panel-body">
                                    <ul class="pading-main">
                                    <li><b>a)Introduction to modeling </b></li>
                                    <li><b>b)Steps of Modeling – </b></li>
                                    <ul class="dashed sub-dashed">
                                    <li>Determine what all models can be identified for the given data set. </li>
                                    <li>Identify significant variable for each model. </li>
                                    <li>Build Model </li>
                                    <li>Check for adequacy of each model using minimally AIC,ROCURVE, AVC </li>
                                    <li>Check for accuracy of each model including using MAC (Minsquare Error) or misclassification percentage as the case may be. </li>
                                    <li>Check for predictability & accuracy of each model using K – Fold cross validation or bootstrap or Jacknife </li>
                                    </ul>
                                    <li><b>C) Types of Models </b></li>
                                    <ul class="syllabus-ul"><li>Operation Research Model </li></ul>
                                    <ul class="sub-dashed dashed">
                                    <li>Liniar   Programing </li>
                                    <li>Non liniar programing</li>
                                    <li>Dynamic Programing </li>
                                    <li>Intiger Programing </li>
                                    <li>Mixed Programing </li>
                                    <li>Mixed Programing </li>
                                    </ul>
                                    <hr />
                                    <ul class="syllabus-ul"><li>Statistical Models </li></ul>
                                       <ul class="sub-dashed dashed">
                                       <li> Classical Statistical Model</li>
                                          <ul class="sub-dashed dashed">
                                          <li> Classification</li>
                                             <ul class="sub-dashed syllabus-ul">
                                             <li> Multiple liniar regression</li>
                                             <li> Stepwise Regression</li>
                                             <li> RIDGE Regression</li>
                                             <li> LASSO Regression</li>
                                             <li> POISSON Regression</li>
                                             <li> Logistic regression </li>
                                             <li> SVM, ANN,CNN,RNN </li>
                                             <li> Tree based models </li>
                                             <li> K nearest neighbor </li>
                                             <li> CART </li>
                                             <li> PRUNED Tree </li>
                                             <li> BAGGING TREE </li>
                                             <li> RANDOM FOREST </li>
                                             <li> BOOSTING </li>
                                             </ul>
                                          </ul>
                                       </ul>
                                       <ul class="sub-dashed dashed">
                                          <li> Bayesan Model</li>
                                          <ul class="sub-dashed dashed">
                                          <li> Naïve Bayse</li>
                                          <li> Classifier, Wavel of regression</li>
                                          </ul>
                                       </ul> 
                                       <ul class="sub-dashed dashed">
                                          <li>Ensembling (Hybrid) Model</li>
                                       </ul> 
                                    </ul>
                                 </div>
                              </div>
                           </div>
                         
                           <div class="panel panel-info">
                              <div class="panel-heading" id="de_heading7" data-toggle="collapse"
                                 href="#de_syllabus7" aria-expanded="true" aria-controls="de_syllabus7">
                                 <h6 class="panel-title">
                                    <i class="indicator fa fa-minus"></i>Clustering
                                 </h6>
                              </div>
                              <div id="de_syllabus7" class="collapse show" aria-labelledby="de_heading7"
                                 data-parent="#de_syllabus">
                                 <div class="panel-body">
                                    <ul class="syllabus-ul">
                                    <li> Concept & provocation </li>
                                    <li> Types of clustering </li>
                                    <li> Distance Concept </li>
                                    <li> Clustering method </li>
                                    <li> Case Study </li>
                                    </ul>
                                 </div>
                              </div>
                           </div>
                          
                           <div class="panel panel-info">
                              <div class="panel-heading" id="de_heading8" data-toggle="collapse"
                                 href="#de_syllabus8" aria-expanded="true" aria-controls="de_syllabus8">
                                 <h6 class="panel-title">
                                   <i class="indicator fa fa-minus"></i>Market Basket Analysis
                                 </h6>
                              </div>
                              <div id="de_syllabus8" class="collapse show" aria-labelledby="de_heading8"
                                 data-parent="#de_syllabus">
                                 <div class="panel-body">
                                    <ul class="syllabus-ul">
                                    <li> Frequent item set concept </li>
                                    <li> Support, confidence & lift </li>
                                    <li> Apriori algorithm </li>
                                    <li> (Aim of MBA is to select most frequent level combination of EDA)</li>
                                    </ul>
                                 </div>
                              </div>
                        
                           </div>
                           <div class="panel panel-info">
                              <div class="panel-heading" id="de_heading12" data-toggle="collapse"
                                 href="#de_syllabus12" aria-expanded="true" aria-controls="de_syllabus12">
                                 <h6 class="panel-title">
                                    <i class="indicator fa fa-minus"></i>Predictive Analytics 
                                 </h6>
                              </div>
                              <div id="de_syllabus12" class="collapse show" aria-labelledby="de_heading12"
                                 data-parent="#de_syllabus">
                                 <div class="panel-body">
                                    <ul class="syllabus-ul">
                                    <li> Refinement of models with inclusion of new found explanatory variable based on descriptive analysis.</li>
                                    </ul>
                                    <ul class="syllabus-ul ">
                                          <li>Time Series Analysis </li></ul>
                                       <ul class="sub-dashed dashed">
                                       <li>Introduction to TSA </li>
                                       <li>Errors in TSA – MAPE,MAD,MSE</li>
                                       </ul>
                                   
                                    <ul class="syllabus-ul ">
                                        <li>Family of Time Series module </li></ul>
                                       <ul class="sub-dashed dashed">
                                       <li> Trend Models </li>
                                       <li> Decomposition models</li>
                                       <li> Exponential smoothing models</li>
                                       <li> ARIMA</li>
                                       <li> Mix models</li>
                                       </ul>
                                   
                                    <ul class="syllabus-ul ">
                                        <li>Prediction Strategy </li></ul>
                                       <ul class="sub-dashed dashed">
                                       <li> Time series based prediction </li>
                                       <li> Cause based modeling</li>
                                       <li> Determine sting prediction</li>
                                       <li> Intuity forecasting</li>
                                       </ul>
                                   
                                   
                                 </div>
                              </div>
                          
                          
                           </div>
                         
                           <div class="panel panel-info">
                              <div class="panel-heading" id="de_heading9" data-toggle="collapse"
                                 href="#de_syllabus9" aria-expanded="true" aria-controls="de_syllabus9">
                                 <h6 class="panel-title">
                                    <i class="indicator fa fa-minus"></i>R  Studio 
                                 </h6>
                              </div>
                              <div id="de_syllabus9" class="collapse show" aria-labelledby="de_heading9"
                                 data-parent="#de_syllabus">
                                 <div class="panel-body">
                                 <ul class="syllabus-ul">
                                       <li> Introduction to R and R studio  </li>
                                       <li> R Installation - R GUI and Rstudio, R Studio tour </li>
                                       <li> R packages overview and understanding in-built functions - Creating/saving R script, Installing packages with coding and with drop down menu, Loading packages, Understanding 4 consoles. </li>
                                       <li> Visual Analytics  </li>
                                       <li> Testing of hypothesis and Confidence Interval  </li>
                                       <li> Linear Regression </li>
                                       <li> Logistic Regression  </li>
                                       <li> Decision Trees/CART  </li>
                                       <li> Confidence Interval and Sample size determination </li>
                                       <li> Supervised and Unsupervised learning </li>
                                       <li> Naïve Bayes Classifier  </li>
                                       <li> Principal Component Analysis </li>
                                       <li id="Outcomes"> Factor Analysis </li>
                                       <li> Discriminant Analysis </li>
                                       <li> k-means clustering </li>
                                       <li > Market Basket Analysis </li>
                                 </ul>
                                 </div>
                              </div>
                           </div>
                         

                           </div>
                        </div>
                      
                     </div>
               </div>
              
            </section>












          
            <section class="course-learning-outcome bg-secondary " id="course-learning-outcome">
               <div class="row">
                  <div class="col-sm-6">
                     <h3>Learning Outcomes</h3>
                     <ul class="lo-ul">
                        <li>Eduplusnow's Data Analytics program using R will make you an expert in data analysis. In this Data Analytics course you will learn analytics tools and techniques how to work with R and how to apply statistics and predictive analytics in a business environment.
                        </li>
                     </ul>
                     <br />
                     <h5>Assessment </h5>
                     <p align="justify" id="Review">
                        Periodic assessment and case studies evaluations by edu plus now have been built in throughout the duration of the course.
                     </p>
                  </div>
                  <div class="col-sm-6">
                     <img alt="datascience18" src="/assets/images/icons/certificate1.png" />
                     <p class="img-below-text text-center">Awarded by edu plus now  </p>
                  </div>
               </div>
            </section>
           
            <section class="course-admission-process" id="course-admission-process1">

               <br />	 
               
            </section>
            <Aboutuslearners />     
            <Aluminicompany />

            <section class="courses-feesm">
            <section class="course-fees" id="course-fees">
            <div class="row box-sh" >
                   <div class="col-sm-12 col-lg-12	col-xl-5  pd-fee" >
                     
                   </div>
                    <div class="vertical-line-fee"> </div>
                    <div class="col-sm-12 col-lg-12 col-xl-6 pd-fee">
                        <div class="row">
                            <div class="col-sm-10"> <br /><br />
                                <h5>Features</h5>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12 col-sm-12">
                              <ul class="highlight-ss" >
                                 <li>	In depth coverage of Data Prepration.</li>
                                 <li>	Basic Analytics</li>
                                 <li>	Prescriptive Analytics.</li>
                                 <li>  Exploratory Data Analytics.</li>
                                 <li> Descriptive Analytics & Predictive analytics using Classification.</li>
                                 <li> Clustering & Time Series Analytics.</li>
                                 <li> Case studies and Hands-on from Live data set.</li>
                              </ul>
                            </div>
                            <p>{// eslint-disable-next-line
                                    } <marquee onmouseover="this.stop();" onmouseout="this.start();" class="marquee-enroll" >"If a group of four or more participants enroll with us, a concession of 10% will be awarded to each one of them. For more details Contact us."<a href="tel://8956167195 " > &nbsp;&nbsp;<i class="fa fa-mobile" aria-hidden="true"></i> +91 8956167195</a></marquee>
                           </p>   
                             <p align = "justify" class="font-text-alumni" ><span>*</span>Alumni of Eduplusnow, VIT, VIIT, VU Will Get Special Discount, To Grab your Discount coupon Please Contact  &nbsp; <a href="tel://8956167195" class="contact-us-mobile"> <i class="fa fa-phone icon-tick"> </i>+918956167195. </a><br /></p>

                        </div> 
                        </div>
                </div>
             </section> 
             </section> 
           
             <Whyedu/>
            <section class="course-about-instructor bg-secondary " id="course-about-instructor">
            <div class="row">
            <div class="col-sm-12">
            <h3>
            About the Organization
            </h3>
            <br />
            <img alt="datascience23"width="200px" src="/assets/images/eduplusnow.png" />
            <br /><br />
            <p align="justify">edu plus now is an online educational platform that was launched in 2019 to bridge the skill gap between classroom learning, real business challenges and to help students achieve their career potential.
            </p>
            <br />
            <p align="justify">Aimed at providing learners with essential technical skills, edu plus now courses are created to be the perfect amalgamation of inputs from industry experts and highly-qualified professors from the country’s top educational institutions. This allows individuals and companies to close the skill gap quickly, innovate faster and achieve their key objectives. At edu plus now, we believe in preparing students for success in a changing world by providing online courses that pave the path for a successful career. Built under the aegis of the Vishwakarma Group, the online education platform provides flexible learning that fits a learner’s schedule. 
            </p>
            </div>
            </div>
            </section>
            <section>
                
            </section>
            

      
         <div class="modal fade bd-example-modal-sm" id="myModal" role="dialog" >
            <div class="modal-dialog modal-md">
             
               <div class="modal-content">
                  <div class="modal-header" >
                     <span class="close" id="close_form"
                      data-dismiss="modal">&times;</span>
                     <br />
                  </div>
                  <div class="modal-body" >
                     <div class="panel panel-default paper-shadow box_detail" >
                        <h5 class="text-center "> Download The Course Brochure </h5>
                        <form method="post" class="form-row"  onsubmit="return validate()" >
                           <b>Your Name</b><input class="form-control" pattern="[A-Za-z ]{1,32}" type="text"
                              required="" autocomplete="on" name="name" id="name" />
                           <b>Your email</b><input class="form-control" type="email" required=""
                              autocomplete="on" name="emaill" id="emaill" />
                           <b>Your Contact No</b><input class="form-control" pattern="[7-9]{1}[0-9]{9}"
                              type="tel" required="" autocomplete="on" name="contactt" id="contactt" />
                           <input type="hidden" name="id" id="exd-course-name" value='<?php echo $words[0]; ?>' />
                           <input type="hidden" id="backurl" value="<?php echo $backurl?>" />
                           <br />
                           <div>
                              <div class="form-group">
                                 <div id="recaptcha" class="g-recaptcha"
                                    data-sitekey="6Lejh30UAAAAAPhZirvpXtobtIE80K7NUzsDqKjE"></div>
                                 <div id="captcha"></div>
                              </div>
                           </div>
                          
                           <div class="mob_cb" >
                              <div>
                              </div>
                              <br />
                            
                              <button class="btn_1 rounded" type="button" onclick="getbroucher(<?php echo '\''.$filepath.'\'';?>)"  id="exd-download" ><i class="icon-download"></i> Brochure</button>
                           </div>
                          
                           <br />
                        </form>
                     </div>
                  </div>
               </div>
            </div>
         </div>

            
            </div>
        );
    }
}

export default Certificateinrprograming;